import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsMdnwebdocsComponent } from './simple-icons-mdnwebdocs.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsMdnwebdocsComponent ],
    exports:      [ SimpleIconsMdnwebdocsComponent ],
    bootstrap:    []
})
export class SimpleIconsMdnwebdocsModule {}
